import React from 'react';
import NumberWithHeadingComp from './NumberWithHeadingComp';

const ConfidentialityComp = ({ title, data, count,id }) => {
  return (
    <div className="mt-[30px] flex flex-col" id={id}>
      <p className="text22">
        {count}. {title}
      </p>
      {data.map((uses, index3) => (
        <React.Fragment key={index3}>
          {index3 === 0 ? (
            <>
              {' '}
              <div className="mt-5 flex flex-col">
                <p className="smallText18 text-LightTextParagraph font-bold leading-5">
                  {uses.name}
                </p>
                <div className="mt-4 flex flex-col gap-4">
                  {uses.text.map((list, index4) => (
                    <div className="flex gap-3" key={index4}>
                      {index4 !== 0 && (
                        <p className="w-[6px] h-[6px] bg-LightSecondary rounded-full mt-[6px]"></p>
                      )}
                      <p
                        className="smallText16Normal w-[calc(100%-18px)]"
                        dangerouslySetInnerHTML={{
                          __html: list,
                        }}
                      ></p>
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <>
              <NumberWithHeadingComp data={uses} />
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ConfidentialityComp;
